import { useRef, useState } from 'react'

/**
 * Хук ресайза колонок HTML-таблицы перетаскиванием. Хранит ширины по ключам
 * колонок, отдаёт обработчик старта перетаскивания для маркера на правой
 * границе заголовка. Снимок состояния захватывается в ref, т.к. setState
 * батчится и onMove может выполниться после onUp (иначе null.key → краш).
 */
export function useColumnResize<K extends string>(defaults: Record<K, number>, min = 48) {
  const [widths, setWidths] = useState<Record<K, number>>(defaults)
  const drag = useRef<{ key: K; startX: number; startW: number } | null>(null)

  const startResize = (key: K, e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    drag.current = { key, startX: e.clientX, startW: widths[key] }
    const onMove = (ev: MouseEvent) => {
      const s = drag.current
      if (!s) return
      const w = Math.max(min, s.startW + (ev.clientX - s.startX))
      setWidths((prev) => ({ ...prev, [s.key]: w }))
    }
    const onUp = () => {
      drag.current = null
      document.removeEventListener('mousemove', onMove)
      document.removeEventListener('mouseup', onUp)
    }
    document.addEventListener('mousemove', onMove)
    document.addEventListener('mouseup', onUp)
  }

  return { widths, startResize }
}
